/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCountryDto } from './GetCountryDto';
import {
    GetCountryDtoFromJSON,
    GetCountryDtoFromJSONTyped,
    GetCountryDtoToJSON,
} from './GetCountryDto';
import type { GetEmailAddressDto } from './GetEmailAddressDto';
import {
    GetEmailAddressDtoFromJSON,
    GetEmailAddressDtoFromJSONTyped,
    GetEmailAddressDtoToJSON,
} from './GetEmailAddressDto';

/**
 * 
 * @export
 * @interface GetClientWithSymphonyCodeDto
 */
export interface GetClientWithSymphonyCodeDto {
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetClientWithSymphonyCodeDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    shortname: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    nip?: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    pesel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    place: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    street: string;
    /**
     * 
     * @type {GetCountryDto}
     * @memberof GetClientWithSymphonyCodeDto
     */
    country: GetCountryDto;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    numbers: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    flat: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    isRelated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    internal: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    dealGroupNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    notToSymphony: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    signContractBlock: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    notSendMailFVS: boolean;
    /**
     * 
     * @type {Array<GetEmailAddressDto>}
     * @memberof GetClientWithSymphonyCodeDto
     */
    emailAddresses?: Array<GetEmailAddressDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    overduePaymentReminder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    paymentRequest: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    paymentRequestKRD: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    paymentRequestBlockKRD: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    interest: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    language: GetClientWithSymphonyCodeDtoLanguageEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    hasActivePurchaser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientWithSymphonyCodeDto
     */
    hasActivePosition?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientWithSymphonyCodeDto
     */
    symphonyCode?: string;
}


/**
 * @export
 */
export const GetClientWithSymphonyCodeDtoLanguageEnum = {
    Pl: 'PL',
    En: 'EN'
} as const;
export type GetClientWithSymphonyCodeDtoLanguageEnum = typeof GetClientWithSymphonyCodeDtoLanguageEnum[keyof typeof GetClientWithSymphonyCodeDtoLanguageEnum];


/**
 * Check if a given object implements the GetClientWithSymphonyCodeDto interface.
 */
export function instanceOfGetClientWithSymphonyCodeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "shortname" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "postcode" in value;
    isInstance = isInstance && "place" in value;
    isInstance = isInstance && "street" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "numbers" in value;
    isInstance = isInstance && "flat" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "isRelated" in value;
    isInstance = isInstance && "internal" in value;
    isInstance = isInstance && "dealGroupNumber" in value;
    isInstance = isInstance && "notToSymphony" in value;
    isInstance = isInstance && "signContractBlock" in value;
    isInstance = isInstance && "notSendMailFVS" in value;
    isInstance = isInstance && "overduePaymentReminder" in value;
    isInstance = isInstance && "paymentRequest" in value;
    isInstance = isInstance && "paymentRequestKRD" in value;
    isInstance = isInstance && "paymentRequestBlockKRD" in value;
    isInstance = isInstance && "interest" in value;
    isInstance = isInstance && "language" in value;

    return isInstance;
}

export function GetClientWithSymphonyCodeDtoFromJSON(json: any): GetClientWithSymphonyCodeDto {
    return GetClientWithSymphonyCodeDtoFromJSONTyped(json, false);
}

export function GetClientWithSymphonyCodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientWithSymphonyCodeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'shortname': json['shortname'],
        'name': json['name'],
        'nip': !exists(json, 'nip') ? undefined : json['nip'],
        'pesel': !exists(json, 'pesel') ? undefined : json['pesel'],
        'postcode': json['postcode'],
        'place': json['place'],
        'street': json['street'],
        'country': GetCountryDtoFromJSON(json['country']),
        'numbers': json['numbers'],
        'flat': json['flat'],
        'active': json['active'],
        'isRelated': json['isRelated'],
        'internal': json['internal'],
        'dealGroupNumber': json['dealGroupNumber'],
        'notToSymphony': json['notToSymphony'],
        'signContractBlock': json['signContractBlock'],
        'notSendMailFVS': json['notSendMailFVS'],
        'emailAddresses': !exists(json, 'emailAddresses') ? undefined : (json['emailAddresses'] === null ? null : (json['emailAddresses'] as Array<any>).map(GetEmailAddressDtoFromJSON)),
        'overduePaymentReminder': json['overduePaymentReminder'],
        'paymentRequest': json['paymentRequest'],
        'paymentRequestKRD': json['paymentRequestKRD'],
        'paymentRequestBlockKRD': json['paymentRequestBlockKRD'],
        'interest': json['interest'],
        'language': json['language'],
        'hasActivePurchaser': !exists(json, 'hasActivePurchaser') ? undefined : json['hasActivePurchaser'],
        'hasActivePosition': !exists(json, 'hasActivePosition') ? undefined : json['hasActivePosition'],
        'symphonyCode': !exists(json, 'symphonyCode') ? undefined : json['symphonyCode'],
    };
}

export function GetClientWithSymphonyCodeDtoToJSON(value?: GetClientWithSymphonyCodeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'shortname': value.shortname,
        'name': value.name,
        'nip': value.nip,
        'pesel': value.pesel,
        'postcode': value.postcode,
        'place': value.place,
        'street': value.street,
        'country': GetCountryDtoToJSON(value.country),
        'numbers': value.numbers,
        'flat': value.flat,
        'active': value.active,
        'isRelated': value.isRelated,
        'internal': value.internal,
        'dealGroupNumber': value.dealGroupNumber,
        'notToSymphony': value.notToSymphony,
        'signContractBlock': value.signContractBlock,
        'notSendMailFVS': value.notSendMailFVS,
        'emailAddresses': value.emailAddresses === undefined ? undefined : (value.emailAddresses === null ? null : (value.emailAddresses as Array<any>).map(GetEmailAddressDtoToJSON)),
        'overduePaymentReminder': value.overduePaymentReminder,
        'paymentRequest': value.paymentRequest,
        'paymentRequestKRD': value.paymentRequestKRD,
        'paymentRequestBlockKRD': value.paymentRequestBlockKRD,
        'interest': value.interest,
        'language': value.language,
        'hasActivePurchaser': value.hasActivePurchaser,
        'hasActivePosition': value.hasActivePosition,
        'symphonyCode': value.symphonyCode,
    };
}

